export const regions = {
    aws: [
        'us-east-1',
        'us-east-2',
        'us-west-1',
        'us-west-2',
        'af-south-1',
        'ap-east-1',
        'ap-northeast-1',
        'ap-northeast-3',
        'ap-northeast-2',
        'ap-south-1',
        'ap-southeast-1',
        'ap-southeast-2',
        'ap-southeast-3',
        'ca-central-1',
        'eu-central-1',
        'eu-west-1',
        'eu-west-2',
        'eu-south-1',
        'eu-west-3',
        'eu-north-1',
        'me-south-1',
        'sa-east-1',
    ],
    gcp: [
        'us-central1-a',
        'us-central1-b',
        'us-central1-c',
        'us-central1-f',
        'us-east1-b',
        'us-east1-c',
        'us-east4-b',
        'us-east4-c',
    ]
}